import { Grid, Table, TableContainer } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddButton from "../../../../../common/components/functional/addButton/AddButton";
import SalaryTableBody from "./SalaryTableBody";
import SalaryTableHeaders from "./SalaryTableHeaders";
import { SalaryType } from "../../../../orders/types/salaryType";

type Props = {
  baseComponentCodes: string[];
  personalComponentCodes: string[];
  extraComponentCodes: string[];
  salaryType: SalaryType;
  fields: any[];
  onEdit: (index: number) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onCopy: (index: number) => void;
  canEdit: boolean;
};

const SalaryTable = ({
  baseComponentCodes,
  personalComponentCodes,
  extraComponentCodes,
  salaryType,
  fields,
  onEdit,
  onAdd,
  onRemove,
  onCopy,
  canEdit,
}: Props) => {
  const { t } = useTranslation();

  if (!baseComponentCodes && !personalComponentCodes && !extraComponentCodes)
    return null;

  return (
    <Grid item container>
      <TableContainer>
        <Table sx={{ width: "auto", tableLayout: "auto" }} size="small">
          <SalaryTableHeaders
            baseComponentCodes={baseComponentCodes}
            personalComponentCodes={personalComponentCodes}
            extraComponentCodes={extraComponentCodes}
            salaryType={salaryType}
          />
          <SalaryTableBody
            fields={fields}
            baseComponentCodes={baseComponentCodes}
            personalComponentCodes={personalComponentCodes}
            extraComponentCodes={extraComponentCodes}
            onEdit={onEdit}
            onRemove={onRemove}
            onCopy={onCopy}
            canEdit={canEdit}
          />
        </Table>
      </TableContainer>
      <AddButton
        label={t("common:add")}
        onClick={onAdd}
        sx={{ marginTop: 2, borderRadius: "20px" }}
        accessRightChecks={[canEdit]}
      />
    </Grid>
  );
};

export default SalaryTable;
